import { SettingsMediaImage, Settings, WidgetData } from './data'
import { Widget } from './widget'

export interface TestimonialT {
  content: string
  name: string
  title?: string
  image?: SettingsMediaImage
}

export type TestimonialData = WidgetData & {
  settings: Settings & {
    slides: TestimonialT[]
  }
  widgetType: 'testimonial-carousel'
}

export class TestimonialWidget extends Widget {
  testimonials: TestimonialT[]

  constructor (data: TestimonialData) {
    super(data)
    this.testimonials = data.settings.slides
  }
}
